<template>
  <v-dialog v-model="visible" scrollable :persistent="permitirGuardar" :max-width="anchoMaximo" @click:outside="clickFuera()">
    <v-card width="550" elevation="4">
      <v-card-title :class="claseTitulo">
        <v-icon v-if="icono" class="ml-n2 mr-4 pa-2" style="background: rgba(10,30,30,.1); box-shadow: 2px 2px 5px; border-radius: 5px;">{{icono}}</v-icon>
        {{titulo}}
      </v-card-title>
<!--      <v-card-text :class="classVCardText">-->

      <!-- TABS. -->
      <!-- Primero se crean las pestañas -->
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="basil"
        grow
      >
        <v-tab
          v-for="item in items"
          :key="item"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
  
      <!-- segundo se crea el contenido de cada pestaña con un tab-item -->
      <!-- TAB Empresa -->
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card
             flat height="500" style="overflow: auto; padding: 20px"
          >
            <!-- <pre>{{definicionCampos}}</pre> -->
            <!-- <pre>{{datosRegistro}}</pre> -->
            <v-form :key="visible" v-if="definicionCampos" v-on:submit.prevent v-model="camposValidados" ref="__vform__" :readonly="esAccionEliminar">
              <slot :definicionCampos="definicionCampos" :datosRegistro="datosRegistro" :accionCrud="accionCRUD" :esAccionEliminar="esAccionEliminar">
                <span v-for="(dc, nombreCampo) in definicionCampos" :key="nombreCampo">
                  <template v-if="!procedeVisualizarCampo(dc)"></template>
                  <template v-else>
                    <CampoFormularioDatos
                      :nombre-campo="nombreCampo"
                      :definicion-campos="definicionCampos"
                      :datos-registro="datosRegistro"
                      :readonly="esAccionEliminar"
                      :disabled="dc.solo_lectura ? dc.solo_lectura.includes (accionCRUD) : false"
                      :ref="nombreCampo"
                    />
                  </template>
                </span>
              </slot>
            </v-form>

            <v-select
            v-model="favorito"
            :items="descripcionDescuentos"
            label="Descuento favorito"            
            >
            </v-select>  
          </v-card>
        </v-tab-item>

        <!-- TAB Descuentos -->
        <v-tab-item>
          <v-card
            color="basil"
            flat height="500" style="overflow: auto; padding: 20px"
          >
            <v-col>
              <v-data-table
                  class="elevation-1"
                  v-model="seleccionados"
                  :items="descuentosVinculables"
                  :items-per-page="10"
                  :headers="cabecerasDescuentos"
                  :hide-default-footer="true"
                  :single-select="!multipleSelect"
                  show-select >

                <!-- titulo -->
                <template v-if="titulo_descuento" v-slot:top>     
                  <v-toolbar dense flat color="#b0b0c0">
                    <v-toolbar-title>
                        <v-icon v-if="icono_descuento" class="mt-n1 mr-1">{{icono_descuento}}</v-icon>
                        {{titulo_descuento}}
                    </v-toolbar-title>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-col>
          </v-card>
        </v-tab-item>
      </v-tabs-items>







<!--      </v-card-text>-->
      <v-card-actions class="mt-n1">
        <v-spacer />
        <v-btn v-if="!esAccionEliminar" text color="green darken-2" @click="guardar" :disabled="!permitirGuardar">Guardar</v-btn>
        <v-btn v-else text color="red darken-2" @click="eliminar">Eliminar</v-btn>
        <v-btn text color="black lighten-2" @click="cancelar">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CONSTANTES_CRUD from "@/constantesCRUD"
import api from "@/api"
import CampoFormularioDatos from '../components/CampoFormularioDatos.vue'
import Vue from "vue"

export default {
  components: { CampoFormularioDatos },
  props: {
    icono: String,
    anchoMaximo: {
      type: String,
      default: "550",
    },
    sinMargenes: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    this.registroOriginal = null;
    this.copiaDatosRegistro = null;
    this.funcionAccion = null;
    this.funcionCancelar = null;
    this.eventos = null;
    return {
      visible: false,
      camposValidados: false,
      claseTitulo: "",

      accionCRUD: "",
      titulo: "",
      definicionCampos: null,
      datosRegistro: null,

      // descuentos seleccionados en un momento dado
      seleccionados: [
      ], // fin array descuentos seleccionados   */    
      
      // descuentos vinculables del parking
      descuentosVinculables: [
      ], // fin array descuentos vinculables   */    

      // descripcion de descuentos para seleccionar el favorito
      descripcionDescuentos: [
      ], // fin array descripcion descuentos  */   
      favorito: '', 
 
      // cabeceras de datos a mostrar en la tabla
      cabecerasDescuentos: [
        { text: 'Descripción', value: 'descripcion', align: 'start', sortable: false},
      ], // fin objeto cabecerasDescuentos

      // Configuracion de la tabla de descuentos
      multipleSelect: true,
      titulo_descuento: "",
      icono_descuento: "",    
      
      // definicion de tabs en el dialogo
      tab: 0,
      items: [
        'Empresa', 'Descuentos permitidos',
      ],
     }
  },
  computed: {
    classVCardText() {
      let clases='';
      if (this.sinMargenes)
        clases = clases + " pa-0";
      else
        clases = clases + " pt-8";
      return clases;
    },
    permitirGuardar() {
      return this.camposValidados && this.elRegistroHaSidoModificado();
    },
    esAccionEliminar() {
      return this.accionCRUD == CONSTANTES_CRUD.ACCION.DELETE;
    }
  },

  watch: {
    // al cambiar el array seleccionados se activa esta funcion
    seleccionados: function () {

      /* Actualizo los descuentos que se muestran en la seleccion de descuento favorito */
      var desDescuentos = ['Ninguno'];
      for (var indice2 in this.seleccionados) {
        desDescuentos.push(this.seleccionados[indice2].descripcion);
      }
      this.descripcionDescuentos = desDescuentos;

      this.datosRegistro['desper'] = JSON.stringify(this.seleccionados);      
    },
    
    // al cambiar el descuento favorito se activa esta funcion
    favorito: function () {
      this.datosRegistro['desdesfav'] = this.favorito;      
    }
 }, // fin watch

  methods: {
    procedeVisualizarCampo (dc) {
      // ñapa total
      if ((dc.visibilidad) && (dc.visibilidad.toUpperCase().includes('XX'))) {
        if (this.$store.state.operador.instalacion.id_ins == null) {
          dc.visibilidad = null;
        }
      }
      
      
      return dc.visibilidad ? dc.visibilidad.toUpperCase().includes(this.accionCRUD) : true;
    },
    elRegistroHaSidoModificado() {
      let hanHabidoCambios = false;
      if (this.datosRegistro) {
        Object.keys (this.datosRegistro).forEach ( (nombreCampo) => {
          if (nombreCampo.includes ('__VT')) // omitimos campos que albergan los valores transformados
            return;
          hanHabidoCambios = hanHabidoCambios || (this.datosRegistro[nombreCampo] != this.copiaDatosRegistro[nombreCampo]);
        });
      }
      return hanHabidoCambios;
    },
    arrayCambiosEnRegistro (){
      let registroAux = {};
      // console.log ('this.copiaDatosRegistro', this.copiaDatosRegistro);
      // console.log ('this.datosRegistro', this.datosRegistro);
      Object.entries (this.datosRegistro).forEach ( ([nombreCampo, valor]) => {
        if (nombreCampo.includes ('__VT') || nombreCampo.includes ('__AUX')) // omitimos campos auxiliares
          return;
        if (this.datosRegistro[nombreCampo] == this.copiaDatosRegistro[nombreCampo])
          return; // omitimos los campos que no han sido modificados
        let dc = this.definicionCampos [nombreCampo];
        if (dc.extra && (dc.extra.toUpperCase() == "AUTO_INCREMENT"))
          return; // omitimos los campos "auto_increment"
        if (dc.contrasena)
          nombreCampo = "(contrasena)_" + nombreCampo;
        registroAux [nombreCampo] = valor;
      });
      return registroAux;
    },
    ocultar(cancelado) {
      // lanzamos el evento "antesCerrarFormulario"
      if (this.eventos.antesCerrarFormulario)
        if (!this.eventos.antesCerrarFormulario (this, cancelado))
          return;

      this.visible = false;
    },
    guardar() {
      if (this.funcionAccion != null) {
        let arrayCambiosEnRegistro = this.arrayCambiosEnRegistro();

        // lanzamos el evento "Antes de Guardar"
        if (this.eventos.antesGuardar)
          this.eventos.antesGuardar (this, arrayCambiosEnRegistro);

        this.funcionAccion (this, arrayCambiosEnRegistro)
          .then (() => {
            // lanzamos el evento "Despues de Guardar"
            if (this.eventos.despuesGuardar)
              this.eventos.despuesGuardar (this, arrayCambiosEnRegistro);

            this.ocultar();
          });
      }
    },
    eliminar() {
      if (this.funcionAccion != null) {
        this.funcionAccion (this)
          .then (() => {
            this.ocultar();
          })
      }
    },
    cancelar() {
      if (this.funcionCancelar != null) {
        if (this.funcionCancelar (this))
          this.ocultar();
      } else
        this.ocultar();
    },
    clickFuera (){
      if (!this.permitirGuardar)
        this.cancelar();
    },
    mostrar (accionCRUD, titulo, definicionCampos, registro, eventos) {
      this.accionCRUD = accionCRUD;
      this.titulo = titulo;
      this.definicionCampos = definicionCampos;
      this.registroOriginal = registro;
      this.datosRegistro = Vue.observable ( {...registro} ); // copiamos (haciendo reactivos) los campos del registro
      this.copiaDatosRegistro = {...registro}; // importante: hacemos una copia de "registro" para poder hacer UPDATES y además, saber qué ha cambiado
      this.funcionAccion = eventos.botonAccion;
      this.funcionCancelar = eventos.botonCancelar;
      this.eventos = eventos;

      // antes de que puedan ser establecidos, hacemos reactivos todos los posibles campos del registro (según la definicion de campos)
      for (const nombreCampo in this.definicionCampos)
        this.$set (this.datosRegistro, nombreCampo, this.datosRegistro [nombreCampo]); // Vue.set

      // establecemos el titulo del formulario segun la accion
      if (this.accionCRUD == CONSTANTES_CRUD.ACCION.UPDATE)
        this.claseTitulo = "tituloModificar"
      else if (this.accionCRUD == CONSTANTES_CRUD.ACCION.DELETE)
        this.claseTitulo = "tituloEliminar"
      else
        this.claseTitulo = "tituloNuevo";

      // asignamos valores por defecto a campos con NULL
      for (const nombreCampo in this.definicionCampos) {
        const dc = this.definicionCampos[nombreCampo];
        if ((this.accionCRUD == CONSTANTES_CRUD.ACCION.CREATE) && (this.datosRegistro[nombreCampo] == null) && ('valor_por_defecto' in dc))
          this.datosRegistro [nombreCampo] = dc.valor_por_defecto;

        // ñapa total
        if ((dc.visibilidad) && (dc.visibilidad.toUpperCase().includes('XX'))) {
          if (this.$store.state.operador.instalacion.id_ins) {
             this.datosRegistro [nombreCampo] = this.$store.state.operador.instalacion.id_ins;
          }
        }


      }

      // necesario: Reiniciar el estado de validacion del formulario cada vez que abrimos (si no lo hacemos, puede saltar las
      // validación en campos que todavía no han sido "tocados")
      if (this.$refs['__vform__'])
        this.$refs['__vform__'].resetValidation();

      // lanzamos el evento "Antes de Abrir"
      if (this.eventos.antesAbrir)
        this.eventos.antesAbrir (this);

      // finalmente, mostramos el dialogo:
      this.visible = true;

      // si la accion es Añadir, ponemos el foco automaticamente en el primer campo
      if (this.accionCRUD == CONSTANTES_CRUD.ACCION.CREATE) {
        setTimeout (() => {
          for (var nombreCampo in this.definicionCampos) {
            if (this.procedeVisualizarCampo (this.definicionCampos [nombreCampo]))
              if (this.$refs[nombreCampo] != undefined) {
                this.$refs[nombreCampo][0].focus();
                break;
              }
          }
        }, 250);
      }
    },
    prepararYMostrar (accionCRUD, titulo, tabla, condicion, eventos) {
      let parametros = {};
      if (accionCRUD == CONSTANTES_CRUD.ACCION.CREATE)
        parametros = { _esquema: true }
      else
        parametros = condicion;

      api.obtenerRegistrosTablaVista (tabla, parametros)
        .then ((respuesta) => {
          let registro = {};
          if (respuesta.data.filas) {
            if (respuesta.data.filas.length == 1)
              registro = respuesta.data.filas[0];
            else
              throw "La consulta ha devuelto más de 1 registro!";
          }
          this.mostrar (accionCRUD, titulo, respuesta.data.definicionCampos, registro, eventos);
        });
    }
  },
};
</script>

<style>
.tituloNuevo {
  background-color: #C0F0C0;
}
.tituloModificar {
  background-color: #90D0F0;
}
.tituloEliminar {
  background-color: #FFA09C;
}
</style>